export default function MainPage() {
    return (
        <center>
            행정마당 관리자 페이지
        </center>
    );
}